import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip } from "antd";
import InputForm from "./InputForm";
import { CPFValido, CNPJValido } from '../utils/Validator';
import { maskTelefone, maskCNPJ, maskCPF } from '../utils/Masker';
import axios from 'axios';
import "./Form.css";
import MunicipioFrame from './MunicipioFrame';
import GrupoPessoaFrame from './GrupoPessoaFrame';

const { Item: ItemForm } = Form;


export const OPCOES_COMBO_TIPO_IE = [
  { key: '1', label: '1 CONTRIBUINTE' },
  { key: '2', label: '2 ISENTO (CONTRIBUINTE SEM IE)' },
  { key: '9', label: '9 NÃO CONTRIBUINTE' },
]


export default class PessoaForm extends Component {
  state = {
    registro: {
      pes_codigo: 0,
      pes_nome: '',
      pes_razao_social: '',
      pes_situacao: '',
      pes_cep: '',
      pes_endereco: '',
      pes_complemento: '',
      pes_bairro: '',
      pes_numero: '',
      pes_cidade: '',
      cmun_uf: '',
      pes_cliente: false,
      pes_fornecedor: false,
      pes_transportador: false,
      pes_sit_fin: false,
      pes_grupo: { key: '0' },
    },
    visualizar: false,
    carregandoCEP: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
        tipoTela: this.props.registroSelecionado.tipoTela,
      }, () => {
        this.refs.pes_cpf_cnpj.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangeMunicipio = event => {
    const { registro } = this.state;
    registro['pes_municipio'] = event.pes_municipio;
    this.setState(event);
  }

  onChangeGrupoPessos = event => {
    const { registro } = this.state;
    registro['pes_grupo'] = event.pes_grupo;
    this.setState(event);
  }


  onBuscarCEPClick = (cep) => {
    // console.log('onBuscarCEPClick: ', cep);
    this.setState({ carregandoCEP: true })
    const { registro } = this.state;

    fetch("https://viacep.com.br/ws/" + cep + "/json/")
      .then(res => res.json())
      .then(
        (result) => {
          // console.log('onBuscarCEPClick-OK: ', result);
          registro.pes_endereco = result.logradouro;
          registro.pes_bairro = result.bairro;
          registro.pes_municipio = {
            key: String(result.ibge),
            label: result.localidade,
            label: String(result.ibge) + ' - ' + result.localidade,
            cmun_uf: String(result.uf),
            cuf_sigla: result.uf,
          };

          this.setState({
            registro,
            carregandoCEP: false,
          })
        },
        (error) => {
          // console.log('onBuscarCEPClick-ERRO: ', error);
          this.setState({
            carregandoCEP: false,
          })
        }
      )
  }

  onBuscarCNPJClick = (cnpj) => {
    const busca = cnpj
      ? String(cnpj)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
      : '';

    if (busca.length === 14) {
      const { registro } = this.state;
      this.setState({ carregandoCNPJ: true })
      axios.get('/pessoas/buscaCNPJ/' + busca)
        .then(response => {
          const { data } = response;
          // console.log('first', data)
          if (data.sucesso) {
            this.setState({
              registro: {
                ...registro,
                pes_nome: data.razao_social,
                pes_razao_social: data.razao_social,
                pes_endereco: data.logradouro,
                pes_complemento: data.complemento,
                pes_bairro: data.bairro,
                pes_numero: data.numero,
                pes_cep: data.cep,
                pes_fone1: data.telefones && data.telefones[0] ? '(' + data.telefones[0].ddd + ')' + data.telefones[0].numero : '',
                pes_municipio: {
                  key: String(data.cmunicipio),
                  label: data.municipio,
                  cmun_uf: String(data.cuf),
                  cuf_sigla: data.uf,
                },
              },
              carregandoCNPJ: false
            });
          } else {
            Modal.warning({ title: 'Aviso!', content: 'Dados do CNPJ não encontrado' });
            this.setState({
              registro: {
                ...registro,
                pes_nome: '',
                pes_razao_social: '',
                pes_endereco: '',
                pes_complemento: '',
                pes_bairro: '',
                pes_numero: '',
                pes_cep: 0,
                pes_fone1: '',
                pes_municipio: {
                  key: '0',
                  label: '',
                  cmun_uf: '',
                  cuf_sigla: '',
                },
              },
              carregandoCNPJ: false
            });
          }
        }).catch(error => {
          this.setState({ carregandoCNPJ: false });
          console.error(error.response);
          Modal.warning({ title: 'Aviso!', content: 'Dados do CNPJ não encontrado.' });
        })
    }
  }


  onOK = () => {
    const PFJ = this.state.registro.pes_cpf_cnpj ? this.state.registro.pes_cpf_cnpj.replace(/[^\d]/g, '') : '';

    if ((!this.state.registro.pes_nome) || (this.state.registro.pes_nome === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome' });
      return;
    }
    if ((!this.state.registro.pes_grupo) || (this.state.registro.pes_grupo.key === '0') || (this.state.registro.pes_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }
    if ((!this.state.registro.pes_municipio) || (this.state.registro.pes_municipio.key === '0') || (this.state.registro.pes_municipio.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Município' });
      return;
    }
    if ((!this.state.registro.pes_cliente) && (!this.state.registro.pes_fornecedor) && (!this.state.registro.pes_transportador)) {
      Modal.warning({ title: 'Aviso!', content: 'Informe um tipo (Cliente/Fornecedor/Transportador)' });
      return;
    }

    this.state.registro.pes_municipio = this.state.registro.pes_municipio.key;
    this.state.registro.pes_cpf_cnpj = this.state.registro.pes_cpf_cnpj ? this.state.registro.pes_cpf_cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.pes_ie = this.state.registro.pes_ie ? this.state.registro.pes_ie.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.pes_ind_ie = this.state.registro.pes_ind_ie && this.state.registro.pes_ind_ie.key ? this.state.registro.pes_ind_ie.key : '9';
    this.state.registro.pes_cep = this.state.registro.pes_cep ? String(this.state.registro.pes_cep).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.pes_grupo = this.state.registro.pes_grupo.key;

    this.props.onSalvarClick(this.state.registro);
  };


  normalizeCpfCnpj = () => {
    const { registro } = this.state;
    const cpfcnpj = registro.pes_cpf_cnpj
      ? registro.pes_cpf_cnpj
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
      : '';
    if (cpfcnpj) {
      if ((String(cpfcnpj).length) === 11) {
        registro['pes_cpf_cnpj'] = maskCPF(cpfcnpj);
        this.setState({ ['pes_cpf_cnpj']: maskCPF(cpfcnpj) });
      } else {
        registro['pes_cpf_cnpj'] = maskCNPJ(cpfcnpj);
        this.setState({ ['pes_cpf_cnpj']: maskCNPJ(cpfcnpj) });
      }
    }
  };








  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoCEP, tipoTela } = this.state;
    const { pes_codigo, pes_nome, pes_razao_social, pes_cpf_cnpj, pes_ie, pes_ind_ie, pes_produtor_rural, pes_cep, pes_endereco,
      pes_complemento, pes_obs, pes_bairro, pes_numero, pes_municipio, pes_grupo,
      pes_fone1, pes_fone2, pes_fone3, pes_email, pes_cliente, pes_fornecedor, pes_transportador, pes_sit_fin,
    } = this.state.registro;

    // console.log('PessoaForm.this.state: ', this.state);

    return (
      <Modal
        title={pes_codigo ? ("Edição de " + (tipoTela === 'C' ? "Cliente" : (tipoTela === 'F' ? "Fornecedor" : "Cliente/Fornecedor"))) : ("Cadastro de " + (tipoTela === 'C' ? "Cliente" : (tipoTela === 'F' ? "Fornecedor" : "Cliente/Fornecedor")))}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="pes_codigo"
                value={pes_codigo}
                readOnly
              />
            </Col>

            <Col xs={24} sm={5} style={{}}>
              <span>CPF/CNPJ</span>
              <InputForm
                id="pes_cpf_cnpj"
                ref="pes_cpf_cnpj"
                maxLength={60}
                onChange={this.onChange}
                value={pes_cpf_cnpj}
                validator={value => Boolean(value)}
                onBlur={this.normalizeCpfCnpj}
              // masker={String(pes_cpf_cnpj).length <= 13 ? maskCPF : maskCNPJ}
              />
              {/* <InputForm
                id="pes_cpf_cnpj"
                ref="pes_cpf_cnpj"
                maxLength={20}
                onChange={this.onChange}
                value={pes_cpf_cnpj}
                validator={value => Boolean(value)}
                masker={String(pes_cpf_cnpj).length <= 13 ? maskCPF : maskCNPJ}
              /> */}
            </Col>

            <Col xs={24} sm={1} style={{ paddingRight: 20, marginTop: 25 }}>
              <Tooltip title="Buscar Dados do CNPJ" placement="topLeft">
                <Button
                  type="dashed"
                  icon="search"
                  htmlType="button"
                  loading={carregandoCEP}
                  onClick={() => this.onBuscarCNPJClick(pes_cpf_cnpj)}
                />
              </Tooltip>
            </Col>

            <Col xs={24} sm={4} style={{}} className="camposEspacoDireita">
              <span>Inscr Est</span>
              <InputForm
                id="pes_ie"
                ref="pes_ie"
                maxLength={10}
                onChange={this.onChange}
                value={pes_ie}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{}} className="camposEspacoDireita">
              <span>Tipo</span>
              <InputForm
                type="select"
                id="pes_ind_ie"
                ref="pes_ind_ie"
                value={pes_ind_ie}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_IE}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: 0 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="pes_produtor_rural"
                ref="pes_produtor_rural"
                onChange={this.onChange}
                value={pes_produtor_rural ? true : false}
              >
                Produtor Rural
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Nome *</span>
              <InputForm
                id="pes_nome"
                ref="pes_nome"
                maxLength={60}
                onChange={this.onChange}
                value={pes_nome}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Razão Social</span>
              <InputForm
                id="pes_razao_social"
                ref="pes_razao_social"
                maxLength={60}
                onChange={this.onChange}
                value={pes_razao_social}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={3} style={{ marginTop: -20 }}>
              <span>CEP</span>
              <InputForm
                id="pes_cep"
                ref="pes_cep"
                value={pes_cep}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={1} style={{ marginTop: 4, marginRight: 30 }}>
              <Tooltip title="Buscar Endereço" placement="topLeft">
                <Button
                  type="dashed"
                  icon="search"
                  htmlType="button"
                  loading={carregandoCEP}
                  onClick={() => this.onBuscarCEPClick(pes_cep)}
                />
              </Tooltip>
            </Col>

            <Col xs={24} sm={10} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Endereço</span>
              <InputForm
                id="pes_endereco"
                ref="pes_endereco"
                maxLength={60}
                onChange={this.onChange}
                value={pes_endereco}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={9} style={{ marginTop: -20 }}>
              <span>Complemento</span>
              <InputForm
                id="pes_complemento"
                ref="pes_complemento"
                maxLength={60}
                onChange={this.onChange}
                value={pes_complemento}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Nº</span>
              <InputForm
                id="pes_numero"
                ref="pes_numero"
                maxLength={5}
                onChange={this.onChange}
                value={pes_numero}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Bairro</span>
              <InputForm
                id="pes_bairro"
                ref="pes_bairro"
                maxLength={60}
                onChange={this.onChange}
                value={pes_bairro}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <MunicipioFrame
                label="Município *"
                id="pes_municipio"
                value={pes_municipio}
                width={"100%"}
                onChange={this.onChangeMunicipio}
                descricaoPrimeiroItem="Todos os Municípios"
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Telefone</span>
              <InputForm
                id="pes_fone1"
                ref="pes_fone1"
                value={pes_fone1}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Telefone</span>
              <InputForm
                id="pes_fone2"
                ref="pes_fone2"
                value={pes_fone2}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Telefone</span>
              <InputForm
                id="pes_fone3"
                ref="pes_fone3"
                value={pes_fone3}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Email</span>
              <InputForm
                id="pes_email"
                ref="pes_email"
                value={pes_email}
                maxLength={100}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Grupo *</span>
              <GrupoPessoaFrame
                label=""
                id="pes_grupo"
                value={pes_grupo}
                width={"100%"}
                onChange={this.onChangeGrupoPessos}
                descricaoPrimeiroItem="Selecione um grupo"
              />
            </Col>

            {tipoTela === '' ? (
              <div>
                <Col xs={24} sm={3} style={{ marginTop: -20 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="pes_cliente"
                    ref="pes_cliente"
                    onChange={this.onChange}
                    value={pes_cliente ? true : false}
                  >
                    Cliente
                  </InputForm>
                </Col>
                <Col xs={24} sm={3} style={{ marginTop: -20 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="pes_fornecedor"
                    ref="pes_fornecedor"
                    onChange={this.onChange}
                    value={pes_fornecedor ? true : false}
                  >
                    Fornecedor
                  </InputForm>
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="pes_transportador"
                    ref="pes_transportador"
                    onChange={this.onChange}
                    value={pes_transportador ? true : false}
                  >
                    Transportadora
                  </InputForm>
                </Col>
              </div>
            ) : null}

            <Col xs={24} sm={4} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="pes_sit_fin"
                ref="pes_sit_fin"
                onChange={this.onChange}
                value={pes_sit_fin ? true : false}
              >
                Bloqueio Financeiro
              </InputForm>
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: 0 }}>
              <span>Observação</span>
              <InputForm
                id="pes_obs"
                ref="pes_obs"
                value={pes_obs}
                maxLength={100}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>


          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PessoaForm.js